import React from "react";
import { useNavigate } from "react-router";
import "./Cart.css";

function Cart() {
  let cartData = JSON.parse(localStorage.getItem("cartData")) || [];

  let cartTotal = cartData.reduce(function (acc, cv) {
    return Number((acc + Number(cv.price)).toFixed(2));
  }, 0);

  const navigate = useNavigate();

  const handleDelete = (index) => {
    cartData.splice(index, 1);
    localStorage.setItem("cartData", JSON.stringify(cartData));
    navigate("/cart");
  };

  const handleCartCount=(value)=>{
    
  }
  return (
    <>
      <div className="cartHeading">
        <h1>Your Cart</h1>
        <br />
        <br />
        <h2>Shipment from UnbeatableSale</h2>
        <br />
      </div>
      <div className="mainCart">
        <div className="upper">
          {cartData.map((el, index) => (
            <div key={index} className="cartLeft">
              <div className="leftfirst">
                <img src={el.link} alt="" width="100px" />
              </div>
              <div className="leftSecond">
                <h3>{el.title}</h3>
                <h2>${el.price}</h2>
                <span>+ ${el.percentCashBack} </span>
                <img
                  src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                  alt=""
                  width="13px"
                />
                <span> Cashback</span>
                <br />
                <button onClick={()=>handleCartCount(-1)}>-</button>
                <span>1</span>
                <button onClick={()=>handleCartCount(+1)}>+</button>
              </div>
              <div className="leftThird">
                <button>Save for Later</button>
                <button onClick={() => handleDelete(index)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
        <div className="maincart">
          <div className="orderTotal">
            <div className="orderPrice">
              <h2>Order Total</h2>
              <div className="totalprice">Subtotal :${cartTotal}</div>
            </div>
            <div className="shipping">
              <input type="text" placeholder="zipcode" />
              <button className="estShippingBtn">Estimate Shipping</button>
            </div>
            <button
              className="checkoutBtn"
              onClick={() => {
                navigate("/address");
              }}
            >
              Proceed To Checkout
            </button>
          </div>
        </div>
        <br />
        <br />
      </div>
      <div className="lowerHeading">
        <h3>Store total: : ${cartTotal}</h3>
      </div>
    </>
  );
}

export default Cart;
